<script>
import {VueMaskDirective as mask} from 'v-mask'
import service, {
  buscaCep,
  consultaPlacaChassiPolicia,
  getPublicLinkS3,
  uploadFotoGrvIndividual
} from '../../../../domain/grv/services'
import {isArray, debounce} from 'lodash'
import moment from 'moment'
import BtnCheckPossui from './CheckPossui'
import Vue from 'vue'
import estadosBr from '../../../_default/utils/estados-brasileiros'
import {PROCESSO_ROUBO_FURTO} from '../../../../domain/grv/helpers/tipos-grv'
import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
import {origens} from '../../../../domain/grv/helpers/helpers-notificacao'
import {
  deleteAtendimento,
  listByGrv
} from '../../../../domain/policia-civil/notificacao-atendimento/services/notificacao-atendimento'
import {listByGrv as listTelegramasByGrv, uploadArquivo} from '../../../../domain/policia-civil/notificacao-telegrama/services/notificacao-telegrama'
import ACL from '../../../../domain/acl/tmp-acl'
import {mapGetters} from 'vuex'
import {mockExtraModelDataHora} from '../../../../domain/grv/helpers/grv-mock'
import ArquivosGrv from '../../../website/grvs/components/grv/ArquivosGrv'
import LacresGrv from '../../../website/grvs/components/grv/LacresGrv'
import TituloSecao from '../../../website/grvs/components/grv/TituloSecao'
import {updatePlacaAlterada} from '../../../../domain/policia-civil/pericia/services/pericia'
import {listByContrato} from '../../../../domain/bem-categoria/services/categorias-veiculares'
import BtnMenuPericia from './BtnMenuPericia'
import {fileToBase64} from '../../../_default/utils/fileToBase64'

const POSSUI = '1'
const NAO_POSSUI = '2'
const NAO_MARCA = '5'

const TIPO_ARQUIVO_TELEGRAMA = 8

let templateEquipamento = {id: null, possui: true, equipamento: {id: null, nome: null}}
// let templateAtendimento = {id: null, origem: null, nome: null, email: null, dataNotificacao: null, dataAgendamento: null, valorDiarias: null, diarias: null}
// let templateTelegrama = {id: null, nome: null, vinculo: null, situacao: {id: null, nome: null}, dataPostagem: null, dataRetornoAr: null}

export default {
  components: {
    BtnMenuPericia,
    TituloSecao,
    LacresGrv,
    ArquivosGrv,
    PopupViewer,
    BtnCheckPossui,
    Pericia: () => import('./Pericia'),
    CadastroPolicial: () => import('../../policiais/policial/components/NovoPolicial'),
    NovaCadastroNotificacaoAtendimento: () => import('../cadastro-notificacao-processo/components/NovoCadastroNotificacaoProcesso'),
    NovoCadastroNotificacaoTelegrama: () => import('../cadastro-notificacao-telegrama/components/NovoCadastroNotificacaoTelegrama')
  },
  nome: 'grv-roubo-furto',
  directives: {mask},
  data () {
    return {
      isGgv: false,
      dataRequired: {
        equipamentos: []
      },
      dataRequiredLoaded: false,
      extraModel: JSON.parse(JSON.stringify(mockExtraModelDataHora)),
      data: {
        id: null,
        numero: null,
        ano: null,
        bairroApreensao: null,
        chassi: null,
        numeroMotor: null,
        chavesVeiculo: 1,
        numeroChave: null,
        cidadeApreensao: null,
        cidadeCondutor: null,
        // codigoInfracao: null,
        equipamentos: [],
        // motivoInfracaoOutros: null,
        marca: null,
        modelo: null,
        cor: null,
        vaga: null,
        cpfCondutor: null,
        data: null,
        cepApreensao: null,
        cepRemocao: null,
        dataApreensao: null,
        enderecoApreensao: null,
        enderecoCondutor: null,
        estadoCondutor: null,
        lacres: [],
        matriculaAgenteApreensor: null,
        nivelCombustivel: null,
        nomeAgenteApreensor: null,
        nomeCondutor: null,
        // numeroAutoInfracao: null,
        observacoes: null,
        orgaoEmissorRgCondutor: null,
        placa: null,
        renavam: null,
        rgCondutor: null,
        telefoneCondutor: null,
        // tipoOperacao: 2,
        tipoRemocao: 2,
        volumesInteriorVeiculo: null,
        comRubrica: null,
        rubrica: null,
        comAssinaturaCondutor: null,
        assinaturaCondutor: null,
        comAssinaturaTestemunha: null,
        condutorPresente: null,
        ufApreensao: null,
        orgaoApreensor: 14,
        reboque: null,
        reboquista: null,
        contrato: null,
        bemCategoria: null,
        patio: null,
        kmForaDaCidade: null,
        kmInicialDoReboque: 0,
        complementoApreensao: null,
        complementoCondutor: null,
        codigoGrv: null,
        liberarPorDecisaoJudicial: false,
        liberarPorPrensa: false,
        liberarPorRouboFurto: false,
        arquivos: [],
        atendimentos: [],
        telegramas: [],
        /* grv roubo furto */
        // statusProcesso: null,
        dpOrigem: null,
        roOrigem: null,
        dataRoOrigem: null,
        roApreensaoRecuperacao: null,
        naoEmplacado: false,
        possuiPlacaOriginal: false,
        semPlaca: false,
        sucata: false,
        comRodas: false,
        delito: null,
        localizacaoAtual: null,
        veiculoNaoIdentificado: false,
        periciaRealizada: false,
        formularioOperadora: null,
        formularioPatio: null,
        recebedorPatio: null,
        recebedorCpf: null,
        recebedorRg: null,
        trancado: false,
        indenizado: false,
        veiculoSegurado: false,
        seguradora: null,
        apoliceSinistro: null,
        tipoGev: null,
        observacoesGev: null,
        dataEntregaDevolucao: null,
        tipoDevolucao: null,
        nomeDevolucao: null,
        cpfDevolucao: null,
        telefoneDevolucao1: null,
        telefoneDevolucao2: null,
        telefoneDevolucao3: null,
        telefoneDevolucao4: null,
        entregadorPatio: null,
        policialRecebedorPatio: null,
        unidadePolicialRecebedorPatio: null,
        dataContatoReintegracao: null,
        transferirProcesso: false,
        patioTransferencia: null,
        empresaContratante: null,
        reintegradora: null,
        observacoesReintegracao: null,
        policialApreensao: null,
        seguradoraAssociados: null,
        locadora: null,
        placaOriginal: null,
        situacaoApreensao: null,
        dataSolicitacaoReboque: null,
        dataPrevisaoChegada: null,
        dataChegadaRemocao: null,
        dataSaidaRemocao: null,
        dataEntradaPatio: null,
        dataSaidaPatio: null,
        // kmForaDaCidadeReboquePatio: null,
        // kmInicialDoReboquePatio: 0,
        enderecoRemocao: null,
        bairroRemocao: null,
        ufRemocao: null,
        complementoRemocao: null,
        cidadeRemocao: null,
        kmFinalDoReboque: 0,
        unidadePolicialApreensao: null,
        patentePolicialApreensao: null,
        observacoesReboque: null,
        observacoesEquipamentos: null,
        comAssinaturaPolicial: false,
        comAssinaturaReboquista: false,
        placaAlterada: null,
        dataPlacaAlterada: null,
        tipoGgv: null,
        comChave: false,
        nomeApresentante: null,
        documentoApresentante: null,
        telefoneApresentante: null,
        enderecoApresentante: null,
        bairroApresentante: null,
        ufApresentante: null,
        complementoApresentante: null,
        cidadeApresentante: null
      },
      origens,
      filasAtendimento: [
        {id: 1, nome: 'Agendamento'},
        {id: 2, nome: 'Rodando'}
      ],
      ggv: {
        conforme: false
      },
      edit: false,
      isLoading: false,
      cadastroError: null,
      atualizadoSucesso: null,
      statusOptions: [
        {label: 'Ativo', value: 1, class: 'btn-default'},
        {label: 'Inativo', value: 0, class: 'btn-default'},
        {label: 'Cancelado', value: -1, class: 'btn-default'}
      ],
      estadosBr,
      showFormAtendimento: false,
      atendimentoSelecionado: null,
      showFormTelegrama: false,
      telegramaSelecionado: null,
      showFormPericia: false,
      showFormPolicial: false,
      policialSelecionado: null,
      patentes: [],
      unidadesPoliciais: [],
      seguradoras: [],
      policiais: [],
      entregadoresPatio: [],
      tiposGrv: [],
      reintegradoras: [],
      locadoras: [],
      tiposDevolucao: [],
      situacoesApreensao: [],
      avarias: [],
      filtro: '',
      showOptionsAutocomplete: false,
      loading: false,
      loadingNotificacoes: false,
      formdataFotosParaUpload: [],
      dataRequiredFiltros: [
        'policiais',
        'avarias',
        'patentes',
        'unidadesPoliciais',
        'seguradoras',
        'entregadoresPatio',
        'tiposGrv',
        'reintegradoras',
        'locadoras',
        'tiposDevolucao',
        'situacoesApreensao'
      ],
      filtroPoliciaisList: '',
      tiposArquivoOcultar: [TIPO_ARQUIVO_TELEGRAMA]
    }
  },
  computed: {
    isGrvRegistrada () {
      return this.$route.params.id && this.$route.params.id !== 'registrar'
    },
    ...mapGetters(['isLogged', 'currentUser']),
    ACL () {
      return ACL
    },
    filteredPoliciaisList () { // TODO: Implementar forma melhor! Esse filtro na memória pode ser prejudicial se o array de policiais continuar crescendo
      const {policiais} = this.dataRequired
      if (!this.filtroPoliciaisList.length) return policiais
      const regex = new RegExp(this.filtroPoliciaisList.toLowerCase())
      return policiais.filter(policial => (policial.matricula || '').toLowerCase().match(regex) || policial.nome.toLowerCase().match(regex))
    },
    filteredArquivosTelegrama () {
      const {arquivos = []} = this.data
      return arquivos.filter(a => a.tipo === TIPO_ARQUIVO_TELEGRAMA)
    },
    podeAdicionarAtendimento () {
      const {length} = this.data.atendimentos
      return !length || ACL.check('adicionar_atendimento_grv_extra', this.currentUser.id)
    },
    podeEditarCamposVeiculo () {
      return !this.isGrvRegistrada || ACL.check('editar_campos_placa_chassi', this.currentUser.id)
    },
    podeEditarCampoPatio () {
      // !(data.status !== 0 && edit)
      return !this.isGrvRegistrada
    },
    podeEditarCampoComplementoApreensao () {
      return !this.isGrvRegistrada
    }
  },
  created () {},
  mounted () {
    this.$loaderOverlay.open().message('Carregando dados relacionados')
    const montaDataRequiredFilters = () => {
      let mount = ''
      for (let value of this.dataRequiredFiltros) {
        mount += `&${value}=true`
      }
      return mount
    }
    service.dataRequired(PROCESSO_ROUBO_FURTO, montaDataRequiredFilters())
      .then((response) => {
        this.$loaderOverlay.hide()
        this.dataRequiredLoaded = true
        this.dataRequired = response.data
        if (isArray(this.dataRequired.equipamentos) && this.dataRequired.equipamentos.length > 0) {
          this.dataRequired.equipamentos = this.dataRequired.equipamentos.filter(equipamento => equipamento.policiaCivil)
          for (let i = 0; i < this.dataRequired.equipamentos.length; i++) {
            // this.$set(this.dataRequired.equipamentos[i], 'checked', false)
            // this.$set(this.dataRequired.equipamentos[i], 'possui', false)
            Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'checked', false)
            Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'possui', NAO_MARCA)
          }
        }
        // this.data.numero = this.dataRequired.sequencialGrv

        for (let requiredFieldName of this.dataRequiredFiltros) {
          if (typeof this[requiredFieldName] !== 'undefined') {
            this[requiredFieldName] = this.dataRequired[requiredFieldName]
          }
        }
        this.start()
        console.log(response)
      })
      .catch((response) => {
        this.$loaderOverlay.hide()
        console.log(response)
      })
  },
  activated () {
  },
  destroyed () {
  },
  watch: {
    'data.semPlaca' () {
      if (this.data.semPlaca) {
        this.$refs.placaOstentada.disabled = true
        this.data.placa = ''
      } else {
        this.$refs.placaOstentada.disabled = false
      }
    },
    'data.naoEmplacado' () {
      if (this.data.naoEmplacado) {
        this.$refs.placaOriginal.disabled = true
        this.data.placaOriginal = ''
      } else {
        this.$refs.placaOriginal.disabled = false
      }
    }
  },
  methods: {
    start () {
      this.clearInputFiles()
      this.dataRequiredLoaded = false
      if (this.isGrvRegistrada) {
        this.loadingNotificacoes = true
        this.edit = true
        this.$loaderOverlay.open().message('Carregando GRV')
        if (typeof this.$route.query.ggv !== 'undefined') {
          this.isGgv = true
        }
        service.find(this.$route.params.id, this.isGgv)
          .then((response) => {
            this.$loaderOverlay.hide()
            let data = response.data
            data.reboque = data.reboque ? data.reboque.id : null
            data.orgaoApreensor = data.orgaoApreensor ? data.orgaoApreensor.id : 14 // TODO: Temporário; forçando o id da polícia aqui, por algum motivo algumas grvs não estão cadastrando na api o órgão apreensor
            data.reboquista = data.reboquista ? data.reboquista.id : null
            data.bemCategoria = data.bemCategoria ? data.bemCategoria.id : null
            data.patio = data.patio ? data.patio.id : null
            data.contrato = data.contrato ? data.contrato.id : null

            // data.reboquePatio = data.reboquePatio ? data.reboquePatio.id : null
            // data.reboquistaPatio = data.reboquistaPatio ? data.reboquistaPatio.id : null

            let dataRemocao = JSON.parse(JSON.stringify(data.data))
            this.extraModel.dataRemocao = dataRemocao ? moment(dataRemocao.date).format('L') : null
            this.extraModel.horaRemocao = dataRemocao ? moment(dataRemocao.date).format('LT') : null
            let dataApreensao = JSON.parse(JSON.stringify(data.dataApreensao))
            this.extraModel.dataApreensao = dataApreensao ? moment(dataApreensao.date).format('L') : null
            this.extraModel.horaApreensao = dataApreensao ? moment(dataApreensao.date).format('LT') : null

            const formataData = date => date ? moment(date.date).format('L LT') : null

            data.policialApreensao = data.policialApreensao ? data.policialApreensao.id : null
            data.policialRecebedorPatio = data.policialRecebedorPatio ? data.policialRecebedorPatio.id : null
            data.dataRoOrigem = formataData(data.dataRoOrigem)
            data.dataEntregaDevolucao = formataData(data.dataEntregaDevolucao)
            data.dataContatoReintegracao = formataData(data.dataContatoReintegracao)
            data.dataSolicitacaoReboque = formataData(data.dataSolicitacaoReboque)
            data.dataPrevisaoChegada = formataData(data.dataPrevisaoChegada)
            data.dataChegadaRemocao = formataData(data.dataChegadaRemocao)
            data.dataSaidaRemocao = formataData(data.dataSaidaRemocao)
            data.dataEntradaPatio = formataData(data.dataEntradaPatio)
            data.dataSaidaPatio = formataData(data.dataSaidaPatio)
            data.dataPlacaAlterada = formataData(data.dataPlacaAlterada)
            data.seguradoraAssociados = data.seguradoraAssociados ? data.seguradoraAssociados.id : null
            data.locadora = data.locadora ? data.locadora.id : null
            data.unidadePolicialRecebedorPatio = data.unidadePolicialRecebedorPatio ? data.unidadePolicialRecebedorPatio.id : null
            data.seguradora = data.seguradora ? data.seguradora.id : null
            data.tipoGev = data.tipoGev ? data.tipoGev.id : null
            data.tipoGgv = data.tipoGgv ? data.tipoGgv.id : null
            data.tipoDevolucao = data.tipoDevolucao ? data.tipoDevolucao.id : null
            data.entregadorPatio = data.entregadorPatio ? data.entregadorPatio.id : null
            data.patioTransferencia = data.patioTransferencia ? data.patioTransferencia.id : null
            data.reintegradora = data.reintegradora ? data.reintegradora.id : null
            data.situacaoApreensao = data.situacaoApreensao ? data.situacaoApreensao.id : null
            data.patentePolicialApreensao = data.patentePolicialApreensao ? data.patentePolicialApreensao.id : null
            data.unidadePolicialApreensao = data.unidadePolicialApreensao ? data.unidadePolicialApreensao.id : null

            if (data.policialApreensao) {
              this.setPolicialSelecionado(null, data.policialApreensao)
            }

            /* if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
              this.dataRequired.equipamentos.forEach((e) => {
                let find = data.equipamentos.findIndex((e1) => e1.equipamento.id === e.id)
                if (typeof find !== 'undefined' && find !== -1) {
                  e.checked = true
                  e.possui = data.equipamentos[find].equipamento.possui
                }
              })
            } */
            if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
              data.equipamentos = data.equipamentos.map(item => {
                item.equipamento.possui = item.possui
                if (item.avaria) {
                  item.equipamento.avaria = item.avaria.id
                }
                return item.equipamento
              })
              this.dataRequired.equipamentos.forEach((e) => {
                let find = data.equipamentos.findIndex((e1) => e1.id === e.id)
                if (typeof find !== 'undefined' && find !== -1) {
                  e.checked = true
                  e.possui = data.equipamentos[find].possui
                  e.avaria = data.equipamentos[find].avaria
                  data.equipamentos[find] = e
                }
              })
            }
            this.data = data
            this.listCategoriasBem()
            this.loadingNotificacoes = false
            this.dataRequiredLoaded = true
            console.log(response)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      } else {
        this.extraModel.horaApreensao = moment().format('HH:mm')
        this.dataRequiredLoaded = true
      }
    },
    clearInputFiles () {
      if (this.$refs.fileInptImg) this.$refs.fileInptImg.value = ''
      if (this.$refs.fileInptImgCelular) this.$refs.fileInptImgCelular.value = ''
      if (this.$refs.uploadTelegrama) this.$refs.uploadTelegrama.value = ''
    },
    submit () {
      if (!this.data.numero) {
        alert('Necessário gerar o número da GRV')
        return
      }
      if (this.data.status === 999) {
        alert('Não é possivel editar GRVs de importação Cevera!')
        return
      }
      const dataApreensaoFormatoEn = this.extraModel.dataApreensao.split('/').reverse().join('-')
      const isDataApreensaoMaiorQueHoje = (new Date()).getTime() < (new Date(dataApreensaoFormatoEn)).getTime()
      if (isDataApreensaoMaiorQueHoje) {
        alert('Data de apreensão não pode ser maior que a data atual.')
        this.$refs.dataApreensao && this.$refs.dataApreensao.focus()
        return
      }
      if (this.isGgv) {
        let confirm = window.confirm('Tem certeza que deseja gerar a GGV?')
        if (!confirm) return
      }
      this.cadastroError = null
      this.$loaderOverlay.open().message('Processando')
      this.$bar.start()
      window.setTimeout(() => {
        this.$loaderOverlay.message('Aguarde, registrando GRV...')
      }, 1000)
      let data = JSON.parse(JSON.stringify(this.data))
      // data.data = this.extraModel.dataRemocao + ' ' + this.extraModel.horaRemocao
      data.dataApreensao = this.extraModel.dataApreensao + ' ' + this.extraModel.horaApreensao
      data.data = data.dataApreensao
      if (this.isGgv) {
        data.isGgv = true
        data.ggv = this.ggv
      }
      data.equipamentos = data.equipamentos.map(equip => {
        equip.possui = equip.possui ? POSSUI : NAO_POSSUI
        return equip
      })
      if (this.policialSelecionado) {
        data.policialApreensao = this.policialSelecionado.id
      }

      const CHAVES_COM_CONDUTOR = 1
      const CHAVES_COM_DEPOSITO = 2

      data.chavesVeiculo = data.comChave ? CHAVES_COM_DEPOSITO : CHAVES_COM_CONDUTOR
      data.arquivos = data.arquivos.filter(file => !file.fromCelular)

      service.cadastro(data, this.$route.params.id, PROCESSO_ROUBO_FURTO).then((response) => {
        let callbackEnd = () => {
          this.uploadFotoIndividualGrv(response.data.id)
            .then(() => {
              this.formdataFotosParaUpload = []
              this.$bar.finish()
              this.$loaderOverlay.hide()
              if (this.$route.params.id) {
                this.start()
                this.atualizadoSucesso = true
                this.$el.querySelector('#sucessMsg').focus()
              } else {
                alert('GRV cadastrada com sucesso.')
                // Redirecionar para tela de visualização da grv criada
                this.$router.push({name: 'roubo-furto.visualizar', params: {id: response.data.id}})
              }
            })
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.$loaderOverlay.hide()
        this.cadastroError = response.data.errors
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
    },
    uploadFotoIndividualGrv: async function (grvId) {
      this.$loaderOverlay.message('Cadastrando as fotos, aguarde...')
      let counter = 0
      for (let file of this.data.arquivos) {
        if (file.apagar || !file.arquivo) continue
        ++counter
        this.$loaderOverlay.message(`Cadastrando foto ${counter} de ${(this.data.arquivos || []).length}, aguarde...`)
        try {
          await uploadFotoGrvIndividual(grvId, {data: file.arquivo, filename: 'fotoGrv'})
        } catch (error) {
          console.log('DEU RUIM', error)
        }
      }
      return new Promise(resolve => resolve(console.log('ENVIOU TODAS AS FOTOS!')))
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    },
    marcaEquipamento (e, v) {
      let template = JSON.parse(JSON.stringify(templateEquipamento))
      // this.$set(this.dataRequired.equipamentos[this.dataRequired.equipamentos.indexOf(v)], 'checked', e.target.checked)
      v.checked = e.target.checked
      if (e.target.checked) {
        // template.possui = v.possui
        template = v
        this.$set(template, 'possui', v.possui)
        /* Object.defineProperty(template, 'possui', {
          get () {
            return template.possui
          }
        }) */
        // delete template.equipamento.possui
        this.data.equipamentos.push(template)
      } else {
        this.data.equipamentos = this.data.equipamentos.filter((e) => {
          // return e.equipamento.id !== v.id
          return e.id !== v.id
        })
      }
      console.log(this.data.equipamentos)
    },
    gerarNumeroGrvPoliciaCivil () {
      if (!confirm('Confirmar geração de número para esta GRV ?')) return

      this.$loaderOverlay.open().message('Gerando número da GRV, aguarde...')
      service.gerarNumeroGrvPoliciaCivil()
        .then(response => {
          this.data.numero = response.data.numero
          this.$loaderOverlay.hide()
        })
        .catch(error => {
          alert(`Erro ao gerar numeração\n${this.printError(error.data.errors)}`)
          console.log(error)
          this.$loaderOverlay.hide()
        })
    },
    consultaPlacaChassi (parametro, tipo = null) {
      this.$loaderOverlay.open().message('Carregando dados do veículo')
      consultaPlacaChassiPolicia(parametro, tipo)
        .then((response) => {
          console.log(response)
          this.$loaderOverlay.hide()
          // result = JSON.parse(response.data)
          let data = JSON.parse(response.data)
          if (data.Retorno === 'OK') {
            // this.data.placa = data.Placa
            this.data.chassi = data.Chassi
            this.data.marca = data.DescricaoMarca
            this.data.modelo = data.DescricaoTipo
            this.data.cor = data.DescricaoCor
            this.data.renavam = data.NumeroRenavam
            this.data.ano = data.AnoFabricacao
            this.data.placaOriginal = data.Placa

            if (data.Classificacao === 'LA') {
              this.data.bemCategoria = 1
            } else if (data.Classificacao === 'LB') {
              this.data.bemCategoria = 2
            } else if (data.Classificacao === 'LC') {
              this.data.bemCategoria = 3
            } else if (data.Classificacao === 'PD') {
              this.data.bemCategoria = 4
            }
          } else {
            alert(data.Retorno)
          }
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          alert(response.Retorno)
        })
    },
    openAtendimento (id, grv) {
      this.$router.push({name: 'roubo-furto.cadastro-notificacao-processo.edit', query: {grv: grv}, params: {id: id}})
    },
    openNotificacao (id, grv) {
      this.$router.push({name: 'roubo-furto.cadastro-notificacao-telegrama.edit', query: {grv: grv}, params: {id: id}})
    },
    openFormPericia () {
      this.showFormPericia = true
    },
    closeFormPericia: async function (forceUpdate = false) {
      if (forceUpdate) {
        const _this = this
        this.$loaderOverlay.open().message('Processando...')
        await updatePlacaAlterada(_this.data.id, {}).catch(error => {
          alert('Ocorreu um erro ao atualizar a placa alterada')
          console.log(error)
        })
        this.start()
      }
      this.showFormPericia = false
    },
    openFormPolicial () {
      this.showFormPolicial = true
    },
    closeFormPolicial () {
      // this.carregarPoliciais()
      this.showFormPolicial = false
    },
    setPolicialSelecionado (evt, id = null) {
      if (id === null) return
      const found = this.dataRequired.policiais.find(policial => policial.id === id)
      this.policialSelecionado = found ? JSON.parse(JSON.stringify(found)) : null
    },
    origem (id) {
      const found = this.origens.find(elem => elem.id === id)
      if (!found) return '-'
      return found.nome || '-'
    },
    filaAtendimento (id) {
      const found = this.filasAtendimento.find(elem => elem.id === id)
      if (!found) return '-'
      return found.nome || '-'
    },
    pesquisarCep: debounce(function (cep, sufixo) {
      cep = String(cep).replace(/\D/g, '')
      if (cep.length !== 8) return
      buscaCep(cep)
        .then(({data}) => {
          this.data['endereco' + sufixo] = data.logradouro
          this.data['bairro' + sufixo] = data.bairro
          this.data['cidade' + sufixo] = data.localidade
          this.data['complemento' + sufixo] = data.complemento
          this.data['uf' + sufixo] = data.uf
          // this.$refs.enderecoNumero.focus()
        })
        .catch((error) => {
          console.log(error)
        })
    }, 300),
    deleteAtendimento (id) {
      const podeExcluir = confirm(`Tem certeza q deseja excluir esse atendimento? \n\nESTA OPERAÇÃO NÃO PODE SER DESFEITA`)
      if (!podeExcluir) return
      const atendimentoIndex = this.data.atendimentos.findIndex(atendimento => atendimento.id === id)

      deleteAtendimento(id)
        .then(result => {
          alert('Atendimento excluído!')
          this.data.atendimentos.splice(atendimentoIndex, 1)
        })
        .catch(error => {
          alert('Houve um erro ao excluir o atendimento.')
          console.log(error)
        })
    },
    copiarEnderecoApreensao () {
      this.data.cepRemocao = this.data.cepApreensao
      this.data.enderecoRemocao = this.data.enderecoApreensao
      this.data.bairroRemocao = this.data.bairroApreensao
      this.data.complementoRemocao = this.data.complementoApreensao
      this.data.ufRemocao = this.data.ufApreensao
      this.data.cidadeRemocao = this.data.cidadeApreensao
    },
    listCategoriasBem () {
      listByContrato(this.data.contrato)
        .then(response => {
          this.dataRequired.categoriaBem = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    formatarData (date, format = 'DD/MM/YYYY HH:mm') {
      const {date: dateClone} = JSON.parse(JSON.stringify(date))
      return moment(dateClone).format(format)
    },
    openCadastroAtendimento (id = null) {
      if (id && !isNaN(id, '')) {
        this.atendimentoSelecionado = id
        this.$nextTick(() => { this.showFormAtendimento = true })
        return
      }
      if (!this.podeAdicionarAtendimento) return alert('Você não pode adicionar novos atendimentos')
      this.showFormAtendimento = true
    },
    closeFormAtendimento (forceUpdate = false) {
      this.showFormAtendimento = false
      this.atendimentoSelecionado = null
      if (!forceUpdate) return
      listByGrv(this.data.id)
        .then(response => {
          this.data.atendimentos = response.data
        })
    },
    openCadastroTelegrama (id = null) {
      if (id && !isNaN(id, '')) {
        this.telegramaSelecionado = id
        this.$nextTick(() => { this.showFormTelegrama = true })
        return
      }
      this.showFormTelegrama = true
    },
    closeFormTelegrama (forceUpdate = false) {
      this.showFormTelegrama = false
      this.telegramaSelecionado = null
      if (!forceUpdate) return
      listTelegramasByGrv(this.data.id)
        .then(response => {
          this.data.telegramas = response.data
        })
    },
    openMultipleInputFileTelegrama () {
      this.$refs['uploadTelegrama'].click()
    },
    uploadDocumentoTelegrama: async function (e) {
      this.$loaderOverlay.open()
      const file = await fileToBase64(e.target.files[0])
      try {
        const response = await uploadArquivo(this.data.id, {data: file, filename: 'arquivoTelegrama'})
        this.data.arquivos = response.data.arquivos
      } catch (error) {
        console.log('Erro ao enviar o arquivo: ', error)
        alert('Ocorreu um erro ao enviar o arquivo.')
      } finally {
        this.clearInputFiles()
        this.$loaderOverlay.hide()
      }
    },
    downloadDocumentoTelegrama ({id}) {
      this.$loaderOverlay.open()
      // eslint-disable-next-line no-unreachable
      getPublicLinkS3(id)
        .then(response => {
          const link = document.createElement('a')
          link.href = `${process.env.API_URL}${response.data}`
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$loaderOverlay.hide()
        })
        .catch(error => {
          alert('Ocorreu um erro ao acessar a imagem, tente novamente')
          this.$loaderOverlay.hide()
          console.log(error)
        })
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="dataRequiredLoaded">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <titulo-secao class="bg-warning text-black" v-if="isGgv">
              <strong>GGV</strong><br>
              Você está fazendo a vistoria para guarda deste veículo
            </titulo-secao>
            <div class="bg-light lter b-b wrapper-md" v-else>
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    GRV
                  </h1>
                </div>
                <div class="col-sm-6">
                  <router-link
                    :to="{name: 'roubo-furto.list', query: {grv: data.numero}}"
                    class="pull-right hidden-print"
                    style="clear: left"
                  >
                    <strong class="label no-radius bg-info">Voltar</strong>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="clearfix">
              <div>
                <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">
                  <div class="wrapper">
                    <div class="panel-body">
                      <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                        <div class="m-b-sm font-bold">Erro ao registrar a GRV, corrija e tente novamente</div>
                        <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                      </div>
                      <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
                      <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null" class="alert alert-success">
                        <div class="font-bold">Atualizado com sucesso!</div>
                      </div>
                      <div class="col-sm-12 col-xs-12 m-b" v-if="data.id">
                        <h1 class="font-thin h3">
                          <button @click="openCadastroAtendimento" type="button" class="btn btn-default btn-md m-l-xs pull-right" v-if="ACL.check('restrito_visitante', currentUser.id) && podeAdicionarAtendimento">
                            <i class="fa fa-plus"></i> Cadastrar Atendimento
                          </button>
                          <button @click="openCadastroTelegrama" type="button" class="btn btn-default btn-md m-l-xs pull-right" v-if="ACL.check('restrito_visitante', currentUser.id)">
                            <i class="fa fa-plus"></i> Cadastrar Notificação Telegrama
                          </button>

                          <btn-menu-pericia
                            class="m-l-xs pull-right"
                            :grv="JSON.parse(JSON.stringify(data))"
                            @openFormPericia="openFormPericia"
                            @reload="start"
                          >
                          </btn-menu-pericia>
                        </h1>
                      </div>
                      <div class="form-group">
                        <label for="grv" class="col-sm-2 control-label">GRV</label>
                        <div class="col-sm-10">
                          <input disabled id="grv" type="text" v-model="data.numero" class="form-control" required/>
                          <button type="button" class="btn btn-danger btn-md m-t-sm" @click="gerarNumeroGrvPoliciaCivil" v-if="ACL.check('restrito_visitante', currentUser.id)" :disabled="edit">
                            Gerar número da GRV
                          </button>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dataApreensao" class="col-sm-2 control-label">Data da apreensão</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="dataApreensao" placeholder="dd/mm/yyyy" ref="dataApreensao"
                                     v-model="extraModel.dataApreensao"
                                     v-mask="'##/##/####'" type="text" class="form-control"  required/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="horaApreensao" class="col-sm-4 control-label">Hora da apreensão</label>
                                <div class="col-sm-8">
                                  <input id="horaApreensao" placeholder="00:00"
                                         v-model="extraModel.horaApreensao"
                                         v-mask="'##:##'" type="time" class="form-control"  required disabled readonly/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Pátio</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <select id="patio" v-model="data.patio" class="form-control" :disabled="!podeEditarCampoPatio" required>
                                <option :value="null">Selecione</option>
                                <option :value="patio.id" v-for="patio in dataRequired.patios" :key="patio.id">
                                  {{patio.nome}}
                                </option>
                              </select>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label class="col-sm-4 control-label">Contrato</label>
                                <div class="col-sm-8">
                                  <select id="contrato" v-model="data.contrato" class="form-control" @change="listCategoriasBem" :disabled="data.status !== 0 && edit" required>
                                    <option :value="null">Selecione</option>
                                    <option :value="contrato.id" v-for="contrato in dataRequired.contratos"
                                            :key="contrato.id">{{contrato.nome}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2"></label>
                        <label class="col-sm-2 control-label" v-show="false">Delito</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input type="text" class="form-control" v-model="data.delito" v-show="false"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="dataSolicitacaoReboque" class="col-sm-4 control-label">Data/Hora Solicitação do Reboque</label>
                                <div class="col-sm-8">
                                  <input id="dataSolicitacaoReboque" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'"  v-model="data.dataSolicitacaoReboque"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2"></label>
                        <label class="col-sm-2 control-label" v-show="false">Formulário Operadora</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input type="text" class="form-control" v-model="data.formularioOperadora" v-show="false"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="dataPrevisaoChegada" class="col-sm-4 control-label">Data/Hora Previsão de Chegada</label>
                                <div class="col-sm-8">
                                  <input id="dataPrevisaoChegada" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'"  v-model="data.dataPrevisaoChegada"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2"></label>
                        <label class="col-sm-2 control-label" v-show="false">Formulário Pátio</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input type="text" class="form-control" v-model="data.formularioPatio" v-show="false"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="dataChegadaRemocao" class="col-sm-4 control-label">Data/Hora Chegada Remoção</label>
                                <div class="col-sm-8">
                                  <input id="dataChegadaRemocao" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'"  v-model="data.dataChegadaRemocao"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dpOrigem" class="col-sm-2 control-label">DP Origem</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="dpOrigem" type="text" class="form-control" v-model="data.dpOrigem"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="dataSaidaRemocao" class="col-sm-4 control-label">Data/Hora Saída Remoção</label>
                                <div class="col-sm-8">
                                  <input id="dataSaidaRemocao" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'"  v-model="data.dataSaidaRemocao"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="roOrigem" class="col-sm-2 control-label">RO Origem</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="roOrigem" type="text" class="form-control" v-model="data.roOrigem"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="dataEntradaPatio" class="col-sm-4 control-label">Data/Hora Entrada no Pátio</label>
                                <div class="col-sm-8">
                                  <input id="dataEntradaPatio" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'"  v-model="data.dataEntradaPatio"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dataRoOrigem" class="col-sm-2 control-label">Data RO Origem</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="dataRoOrigem" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataRoOrigem"/>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="roApreensaoRecuperacao" class="col-sm-2 control-label">RO Apreensão/Recuperação</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="roApreensaoRecuperacao" type="text" class="form-control" v-model="data.roApreensaoRecuperacao"/>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="tipoRemocao" class="col-sm-2 control-label">Tipo de remoção</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <select id="tipoRemocao" v-model="data.tipoRemocao" class="form-control">
                                <option :value="1">Rodando</option>
                                <option :value="2">Rebocado</option>
                              </select>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="situacaoApreensao" class="col-sm-4 control-label">Situação de Apreensão</label>
                                <div class="col-sm-8">
                                  <select id="situacaoApreensao" v-model="data.situacaoApreensao" class="form-control">
                                    <option :value="null" disabled>Selecione</option>
                                    <option :value="situacao.id" v-for="situacao in situacoesApreensao">{{situacao.nome}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="liberarJudicial" class="i-checks m-b-none">
                            <input v-model="data.liberarPorDecisaoJudicial" type="checkbox" id="liberarJudicial"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="liberarJudicial">Liberar para Retirada por Decisão Judicial</label>
                        </div>
                      </div><!---->
                    </div><!-- END Padding -->
                  </div>

                  <div class="wrapper" v-if="data.tipoRemocao === 1">
                    <div class="panel-body">
                      <hr>
                      <h4>Dados do Apresentante</h4>

                      <div class="form-group">
                        <label for="nomeApresentante" class="col-sm-2 control-label">Nome</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-7">
                              <input id="nomeApresentante" type="text" v-model="data.nomeApresentante" class="form-control" required/>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="telefoneApresentante" class="col-sm-4 control-label">Telefone</label>
                                <div class="col-sm-8">
                                  <input id="telefoneApresentante" type="text" v-model="data.telefoneApresentante" class="form-control" required/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="cepRemocao" class="col-sm-2 control-label">Documento (RG ou CPF)</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-3">
                              <input id="documentoApresentante" type="text"
                                     v-model="data.documentoApresentante"
                                     class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="cepRemocao" class="col-sm-2 control-label">CEP</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-3">
                              <input id="cepApresentante" type="text"
                                     v-model="data.cepApresentante"
                                     class="form-control"
                                     v-mask="'##.###-###'"
                                     @keyup="pesquisarCep(data.cepApresentante, 'Apresentante')"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="enderecoApresentante" class="col-sm-2 control-label">Endereço</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-7">
                              <input id="enderecoApresentante" type="text" v-model="data.enderecoApresentante"
                                     class="form-control" required/>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="bairroApresentante" class="col-sm-4 control-label">Bairro</label>
                                <div class="col-sm-8">
                                  <input id="bairroApresentante" type="text" v-model="data.bairroApresentante"
                                         class="form-control" required/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="complementoApresentante" class="col-sm-2 control-label">Complemento</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-4">
                              <input id="complementoApresentante" v-model="data.complementoApresentante" type="text"
                                     class="form-control"/>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label for="ufApresentante" class="col-sm-4 control-label">UF</label>
                                <div class="col-sm-8">
                                  <select id="ufApresentante" class="form-control" v-model="data.ufApresentante" required>
                                    <option :value="null" disabled selected>Selecione</option>
                                    <option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="cidadeApresentante" class="col-sm-4 control-label">Cidade</label>
                                <div class="col-sm-8">
                                  <input id="cidadeApresentante" type="text" v-model="data.cidadeApresentante"
                                         class="form-control" required/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Local de Apreensão / Remoção</titulo-secao>
                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="cepApreensao" class="col-sm-2 control-label">CEP Apreensão</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-3">
                              <input id="cepApreensao" type="text"
                                     v-model="data.cepApreensao"
                                     class="form-control"
                                     v-mask="'##.###-###'"
                                     @keyup="pesquisarCep(data.cepApreensao, 'Apreensao')"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="enderecoApreensao" class="col-sm-2 control-label">Endereço Apreensão</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-7">
                              <input id="enderecoApreensao" type="text" v-model="data.enderecoApreensao"
                                     class="form-control"/>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="bairroApreensao" class="col-sm-4 control-label">Bairro Apreensão</label>
                                <div class="col-sm-8">
                                  <input id="bairroApreensao" type="text" v-model="data.bairroApreensao"
                                         class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="complementoApreensao" class="col-sm-2 control-label">Complemento Apreensão</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-4">
                              <input id="complementoApreensao"
                                     v-model="data.complementoApreensao"
                                     type="text"
                                     class="form-control"
                                     :disabled="!podeEditarCampoComplementoApreensao"
                              />
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label for="ufApreensao" class="col-sm-4 control-label">UF Apreensão</label>
                                <div class="col-sm-8">
                                  <select id="ufApreensao" class="form-control" v-model="data.ufApreensao">
                                    <option :value="null" disabled selected>Selecione</option>
                                    <!--<option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>-->
                                    <option value="ES">Espírito Santo</option>
                                    <option value="RJ">Rio de Janeiro</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="cidadeApreensao" class="col-sm-4 control-label">Cidade Apreensão</label>
                                <div class="col-sm-8">
                                  <input id="cidadeApreensao" type="text" v-model="data.cidadeApreensao"
                                         class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr>

                      <div class="form-group">
                        <label for="cepRemocao" class="col-sm-2 control-label">CEP Remoção</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-3">
                              <input id="cepRemocao" type="text"
                                     v-model="data.cepRemocao"
                                     class="form-control"
                                     v-mask="'##.###-###'"
                                     @keyup="pesquisarCep(data.cepRemocao, 'Remocao')"
                              />
                            </div>
                            <div class="col-sm-3">
                              <button type="button" class="btn btn-info btn-sm m-l-xs" @click="copiarEnderecoApreensao">
                                <i class="fa fa-clone"></i> Copiar dados de endereço de apreensão
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="enderecoRemocao" class="col-sm-2 control-label">Endereço Remoção</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-7">
                              <input id="enderecoRemocao" type="text" v-model="data.enderecoRemocao"
                                     class="form-control" required/>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="bairroRemocao" class="col-sm-4 control-label">Bairro Remoção</label>
                                <div class="col-sm-8">
                                  <input id="bairroRemocao" type="text" v-model="data.bairroRemocao"
                                         class="form-control" required/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="complementoRemocao" class="col-sm-2 control-label">Complemento Remoção</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-4">
                              <input id="complementoRemocao" v-model="data.complementoRemocao" type="text"
                                     class="form-control"/>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label for="ufRemocao" class="col-sm-4 control-label">UF Remoção</label>
                                <div class="col-sm-8">
                                  <select id="ufRemocao" class="form-control" v-model="data.ufRemocao" required>
                                    <option :value="null" disabled selected>Selecione</option>
                                    <!--<option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>-->
                                    <option value="ES">Espírito Santo</option>
                                    <option value="RJ">Rio de Janeiro</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="cidadeRemocao" class="col-sm-4 control-label">Cidade Remoção</label>
                                <div class="col-sm-8">
                                  <input id="cidadeRemocao" type="text" v-model="data.cidadeRemocao"
                                         class="form-control" required/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Dados do Veículo</titulo-secao>
                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="comRodas" class="i-checks m-b-none">
                            <input v-model="data.comRodas" type="checkbox" id="comRodas"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="comRodas">Com Rodas</label>
                        </div>
                      </div><!---->

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="semPlaca" class="i-checks m-b-none">
                            <input v-model="data.semPlaca" type="checkbox" id="semPlaca"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="semPlaca">Sem Placa</label>
                        </div>
                      </div><!---->

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="possuiPlacaOriginal" class="i-checks m-b-none">
                            <input v-model="data.possuiPlacaOriginal" type="checkbox" id="possuiPlacaOriginal" tabindex="0"
                                   aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="possuiPlacaOriginal">Placa Original</label>
                        </div>
                      </div><!---->

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="naoEmplacado" class="i-checks m-b-none">
                            <input v-model="data.naoEmplacado" type="checkbox" id="naoEmplacado" tabindex="0"
                                   aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="naoEmplacado">Não Emplacado</label>
                        </div>
                      </div><!---->
                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="sucata" class="i-checks m-b-none">
                            <input v-model="data.sucata" type="checkbox" id="sucata"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="sucata">Sucata</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="placa" class="col-sm-2 control-label">Placa Ostentada</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="placa" ref="placaOstentada" type="text" v-model="data.placa" :disabled="!podeEditarCamposVeiculo" class="form-control"/>
                          </div>
                          <!--<div class="col-sm-7">
                            <button class="btn btn-info btn-sm m-l-xs btn-colsultaGrv" type="button" @click="consultaPlacaChassi">Consultar</button>
                          </div>-->
                        </div>
                      </div>
                    </div>

                    <div class="form-group" v-if="data.periciaRealizada">
                      <label for="placaAlterada" class="col-sm-2 control-label">Placa Alterada</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="placaAlterada" type="text" v-model="data.placaAlterada" class="form-control" disabled/>
                          </div>
                          <div class="col-sm-7">
                            <input id="dataEntregaDevolucao" type="text" class="form-control" placeholder="dd/mm/yyyy hh:mm" v-mask="'##/##/#### ##:##'" v-model="data.dataPlacaAlterada" disabled/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="placaOriginal" class="col-sm-2 control-label">Placa Original</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="placaOriginal" ref="placaOriginal" type="text" v-model="data.placaOriginal" :disabled="!podeEditarCamposVeiculo" class="form-control"/>
                          </div>
                          <div class="col-sm-7">
                            <button class="btn btn-info btn-sm m-l-xs btn-colsultaGrv" type="button" @click="consultaPlacaChassi(data.placaOriginal, 'placa')">Consultar</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="chassi" class="col-sm-2 control-label">Chassi</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="chassi" type="text" v-model="data.chassi" :disabled="!podeEditarCamposVeiculo" class="form-control" required/>
                          </div>
                          <div class="col-sm-7">
                            <button class="btn btn-info btn-sm m-l-xs btn-colsultaGrv" type="button" @click="consultaPlacaChassi(data.chassi, 'chassi')">Consultar</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="numeroMotor" class="col-sm-2 control-label">Número do motor</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="numeroMotor" v-model="data.numeroMotor" type="text" class="form-control"/>
                          </div>
                          <div class="col-sm-5">
                            <div class="form-group">
                              <label class="col-sm-4 control-label">Categoria</label>
                              <div class="col-sm-8">
                                <select id="categoria" v-model="data.bemCategoria" class="form-control">
                                  <option :value="null">Selecione</option>
                                  <option :value="categoriaBem.id" v-for="categoriaBem in dataRequired.categoriaBem"
                                          :key="categoriaBem.id">{{categoriaBem.nome}}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="marca" class="col-sm-2 control-label">Marca/Modelo</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="marca" v-model="data.marca" type="text" class="form-control" required/>
                          </div>
                          <div class="col-sm-5">
                            <div class="form-group">
                              <label for="modelo" class="col-sm-4 control-label">Tipo</label>
                              <div class="col-sm-8">
                                <input id="modelo" type="text" v-model="data.modelo" class="form-control" required/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="cor" class="col-sm-2 control-label">Cor</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="cor" type="text" v-model="data.cor" class="form-control" required/>
                          </div>
                          <div class="col-sm-5">
                            <div class="form-group">
                              <label for="vaga" class="col-sm-4 control-label">Vaga</label>
                              <div class="col-sm-8">
                                <input id="vaga" v-model="data.vaga" type="text" class="form-control"/>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <div class="form-group">
                              <label for="ano" class="col-sm-4 control-label">Ano</label>
                              <div class="col-sm-8">
                                <input id="ano" type="text" v-model="data.ano" class="form-control"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="localizacaoAtual" class="col-sm-2 control-label">Localização Atual</label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <input id="localizacaoAtual" type="text" v-model="data.localizacaoAtual" class="form-control"/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="veiculoComChave" class="col-sm-2 control-label"></label>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-5">
                            <div class="form-group">
                              <div class="col-sm-10">
                                <label for="veiculoComChave" class="i-checks m-b-none">
                                  <input
                                    v-model="data.comChave"
                                    type="checkbox"
                                    id="veiculoComChave"
                                    tabindex="0"
                                    aria-checked="false"
                                    aria-invalid="false"
                                  ><i></i>
                                </label>
                                <label for="veiculoComChave">Veículo possui chaves</label>
                              </div>
                            </div>
                            <!--<select id="veiculoComChave" v-model="data.comChave" class="form-control">
                              <option :value="null" disabled>Selecione</option>
                              <option :value="true">Sim</option>
                              <option :value="false">Não</option>
                            </select>-->
                          </div>
                          <div class="col-sm-5">
                            <div class="form-group">
                              <label for="numeroChave" class="col-sm-4 control-label">Número da chave</label>
                              <div class="col-sm-8">
                                <input id="numeroChave" v-model="data.numeroChave" type="text" class="form-control"/>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <div class="form-group">
                              <label for="renavam" class="col-sm-4 control-label">Renavam</label>
                              <div class="col-sm-8">
                                <input id="renavam" type="text" v-model="data.renavam" class="form-control"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Policial</titulo-secao>
                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label class="col-sm-2 control-label" for="policialFiltro">Filtrar Lista de Policiais</label>
                        <div class="col-sm-10">
                          <input type="text" placeholder="Filtrar por matrícula ou nome" id="policialFiltro" class="form-control" v-model="filtroPoliciaisList">
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Selecionar Policial</label>
                        <div class="col-sm-10">
                          <select id="policial" class="form-control" v-model="data.policialApreensao" @change="setPolicialSelecionado($event, data.policialApreensao)" required>
                            <option :value="null" disabled>Selecione</option>
                            <option :value="policial.id" v-for="policial in filteredPoliciaisList" :key="policial.id">
                              {{policial.nome}}
                            </option>
                          </select>
                          <!--<button type="button" class="btn btn-default btn-xs m-t-xs" @click="openFormPolicial">
                            <i class="fa fa-plus"></i> Cadastrar novo policial
                          </button>-->
                        </div>
                      </div>

                      <div class="form-group" v-if="policialSelecionado">
                        <label for="nomeAgenteApreensor" class="col-sm-2 control-label">Nome</label>
                        <div class="col-sm-5">
                          <input id="nomeAgenteApreensor" type="text" class="form-control" v-model="policialSelecionado.nome" disabled/>
                        </div>
                        <label for="matriculaAgenteApreensor" class="col-sm-2 control-label">Matrícula</label>
                        <div class="col-sm-3">
                          <input id="matriculaAgenteApreensor" v-model="policialSelecionado.matricula" type="text" class="form-control" disabled/>
                        </div>
                        <!--<div class="col-sm-5">
                          <button type="button" class="btn btn-default btn-sm m-l-xs">
                            <i class="fa fa-search"></i> Pesquisar agente
                          </button>
                          <router-link :to="{name: 'policiacivil.policia.policial.novo'}" target="_blank" class="btn btn-default btn-sm m-l-xs" v-if="ACL.check('restrito_visitante', currentUser.id)">
                            <i class="fa fa-plus"></i> Cadastrar Novo Agente
                          </router-link>
                        </div>-->
                      </div>

                      <div class="form-group">
                        <label for="patente" class="col-sm-2 control-label">Patente</label>
                        <div class="col-sm-10">
                          <select name="" id="patente" class="form-control" v-model="data.patentePolicialApreensao">
                            <option :value="null" disabled>Selecione</option>
                            <option :value="patente.id" v-for="patente in patentes" :key="patente.id">{{patente.nome}}</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="unidadePolicial" class="col-sm-2 control-label">Unidade Policial</label>
                        <div class="col-sm-10">
                          <select id="unidadePolicial" class="form-control" v-model="data.unidadePolicialApreensao">
                            <option :value="null">Selecione</option>
                            <option :value="unidadePolicial.id" v-for="unidadePolicial in unidadesPoliciais" :key="unidadePolicial.id">
                              {{unidadePolicial.nome}}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="observacoes" class="col-sm-2 control-label">Observações Veículo</label>
                        <div class="col-sm-10">
                          <textarea id="observacoes" v-model="data.observacoes" rows="7" class="form-control" style="resize: none;"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Dados do Reboque</titulo-secao>
                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="reboquista" class="col-sm-2 control-label">Reboquista</label>
                        <!--<div class="col-sm-10"> TODO: REBOCAR/PERFORM: Implementar seleção externa e input somente do ID ou Código
                          <input id="reboquista" v-model="data.reboquista.codigo" type="text" class="form-control"/>
                        </div>-->
                        <div class="col-sm-10">
                          <select id="reboquista" v-model="data.reboquista" class="form-control" required>
                            <option :value="null">Selecione</option>
                            <option :value="reboquista.id" v-for="reboquista in dataRequired.reboquistas" :key="reboquista.id" :disabled="!reboquista.ativo">
                              {{reboquista.nome}} (#{{reboquista.codigo}}) <span style="font-size: small; color: red" v-if="!reboquista.ativo">(inativo)</span>
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="reboque" class="col-sm-2 control-label">Reboque</label>
                        <div class="col-sm-10">
                          <select id="reboque" v-model="data.reboque" class="form-control" required>
                            <option :value="null">Selecione</option>
                            <option :value="reboque.id" v-for="reboque in dataRequired.reboques" :key="reboque.id" :disabled="!reboque.ativo">
                              {{reboque.placa}} <span style="font-size: small; color: red" v-if="!reboque.ativo">(inativo)</span>
                            </option>
                          </select>
                        </div>
                      </div>

                      <!--<div class="form-group">
                        <label for="kmForaCidade" class="col-sm-2 control-label">KM fora cidade</label>
                        <div class="col-sm-10">
                          <input id="kmForaCidade" v-model="data.kmForaDaCidade" type="text" class="form-control"/>
                        </div>
                      </div>-->

                      <div class="form-group">
                        <label for="kmInicial" class="col-sm-2 control-label">KM inicial</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="kmInicial" v-model="data.kmInicialDoReboque" type="text" class="form-control"/>
                              <small class="col-sm-offset-2 col-sm-10">KM inicial do reboque ao atender o acionamento.</small>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="kmFinal" class="col-sm-2 control-label">KM final</label>
                                <div class="col-sm-8">
                                  <input id="kmFinal" v-model="data.kmFinalDoReboque" type="text" class="form-control"/>
                                  <small class="col-sm-offset-2 col-sm-8">KM final do reboque ao atender o acionamento.</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="observacoesReboque" class="col-sm-2 control-label">Observações</label>
                        <div class="col-sm-10">
                          <textarea id="observacoesReboque" v-model="data.observacoesReboque" rows="7" class="form-control"
                                    style="resize: none;"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Equipamentos / Acessórios</titulo-secao>
                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group b-b padder-v" v-for="equip in dataRequired.equipamentos" :key="equip.id">
                        <div class="col-sm-offset-2 col-sm-10">
                          <div class="row">
                            <div class="col-xs-4">
                              <label class="i-checks m-b-none">
                                <input v-model="equip.checked" @change="marcaEquipamento($event, equip)" type="checkbox"
                                       :id="equip.id"
                                       tabindex="0"
                                       aria-checked="false"
                                       aria-invalid="false"><i></i>
                              </label>
                              <label :for="equip.id">{{equip.nome}}</label>
                            </div>
                            <div class="col-xs-4 form-inline" v-show="equip.checked">
                              <label>Avaria: </label>
                              <select class="form-control" v-model="equip.avaria">
                                <option :value="null" disabled selected>Nenhum</option>
                                <option :value="avaria.id" v-for="avaria in avarias" :key="avaria.id">{{avaria.nome}}</option>
                              </select>
                            </div>
                            <div class="col-xs-4" v-show="false">
                              <btn-check-possui v-model="equip.possui" v-show="equip.checked"/>
                            </div>
                          </div>
                        </div>
                      </div><!---->

                      <div class="form-group">
                        <label for="volumesInteriorVeiculo" class="col-sm-2 control-label">Volumes ou acessórios no
                          interior do veículo</label>
                        <div class="col-sm-10">
                          <input id="volumesInteriorVeiculo" v-model="data.volumesInteriorVeiculo" type="text" class="form-control"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="observacoesEquipamentos" class="col-sm-2 control-label">Observações</label>
                        <div class="col-sm-10">
                          <textarea id="observacoesEquipamentos" v-model="data.observacoesEquipamentos" rows="7" class="form-control"
                                    style="resize: none;"></textarea>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" id="comAssinaturaPolicial" v-model="data.comAssinaturaPolicial"
                                   tabindex="0" aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                          <label for="comAssinaturaPolicial">Com assinatura do policial</label>
                        </div>
                      </div><!---->

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" id="comAssinaturaReboquista" v-model="data.comAssinaturaReboquista"
                                   tabindex="0" aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                          <label for="comAssinaturaReboquista">Com assinatura do reboquista</label>
                        </div>
                      </div><!---->

                    </div>
                  </div>

                  <div class="bg-light lter b-b wrapper-md" v-if="isGgv">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h2 class="font-thin h3">
                          Parecer Final
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper-md m-b-lg" v-if="isGgv">
                    <div class="row">
                      <label class="col-sm-4 control-label">Em conformidade com a GRV</label>
                      <div class="col-sm-8">
                        <select v-model="ggv.conforme" class="form-control">
                          <option :value="true">Conforme</option>
                          <option :value="false">Não conforme</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Lacres</titulo-secao>
                  <lacres-grv :lacres="data.lacres"></lacres-grv>

                  <titulo-secao>Localização</titulo-secao>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                      <thead>
                      <tr>
                        <th>Data de alteração da localização</th>
                        <th>Localização</th>
                        <th>Operador de empilhadeira</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="local in data.historicoLocalizacao">
                        <td scope="row">{{moment(local.dataRegistro.date).format('L LTS')}}</td>
                        <td scope="row">{{local.localizacao && local.localizacao.nome || 'Não informado'}}</td>
                        <td scope="row">{{local.operadorEmpilhadeira && local.operadorEmpilhadeira.nome || 'Não informado'}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <titulo-secao>Notificações de telegrama para este processo</titulo-secao>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Data da Postagem</th>
                        <th>Data de recebimento da AR</th>
                        <th>Situação</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="loadingNotificacoes">
                        <td colspan="6">Carregando...</td>
                      </tr>
                      <tr v-else v-for="telegrama in data.telegramas">
                        <td  scope="row" @click="openCadastroTelegrama(telegrama.id)" role="button" tabindex="0">
                          {{telegrama.nome}}
                        </td>
                        <td scope="row" v-if="telegrama.dataPostagem != null" @click="openCadastroTelegrama(telegrama.id)" role="button" tabindex="0">
                          {{formatarData(telegrama.dataPostagem)}}
                        </td>
                        <td v-else @click="openCadastroTelegrama(telegrama.id)" role="button" tabindex="0"><i>Não cadastrado</i></td>
                        <td scope="row" v-if="telegrama.dataRetornoAr != null" @click="openCadastroTelegrama(telegrama.id)" role="button" tabindex="0">
                          {{formatarData(telegrama.dataRetornoAr)}}
                        </td>
                        <td v-else @click="openCadastroTelegrama(telegrama.id)" role="button" tabindex="0"><i>Não cadastrado</i></td>
                        <td scope="row" v-if="telegrama.situacao != null" @click="openCadastroTelegrama(telegrama.id)" role="button" tabindex="0">
                          {{telegrama.situacao.nome}}
                        </td>
                        <td v-else @click="openCadastroTelegrama(telegrama.id)" role="button" tabindex="0"><i>Não cadastrado</i></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <titulo-secao v-if="filteredArquivosTelegrama.length">Arquivos de telegrama para este processo</titulo-secao>

                  <div class="table-responsive" v-if="filteredArquivosTelegrama.length">
                    <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                      <thead>
                      <tr>
                        <th>Cadastrado em</th>
                        <th>Arquivo</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="loadingNotificacoes">
                        <td colspan="6">Carregando...</td>
                      </tr>
                      <tr v-else v-for="arquivoTelegrama in filteredArquivosTelegrama">
                        <td scope="row" role="button" tabindex="0">
                          {{formatarData(arquivoTelegrama.storageCreatedAt)}}
                        </td>
                        <td scope="row" role="button" tabindex="0">
                          <button class="btn btn-link" @click.stop.prevent="downloadDocumentoTelegrama(arquivoTelegrama)">
                            <i class="fa fa-download"></i> Visualizar arquivo de telegrama
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="wrapper-sm m-t-n m-b" v-if="ACL.check('restrito_visitante', currentUser.id)">
                    <button
                      @click.prevent="openCadastroTelegrama"
                      class="btn btn-info btn-md m-l-xs btn-colsultaGrv"
                      v-if="isGrvRegistrada"
                    >
                      <i class="fa fa-plus"></i> Cadastrar Notificação de Telegrama
                    </button>
                    <button
                      @click.prevent="openMultipleInputFileTelegrama"
                      class="btn btn-info btn-md m-l-xs btn-colsultaGrv"
                      v-if="isGrvRegistrada"
                    >
                      <i class="fa fa-upload"></i> Cadastrar Arquivo de Telegrama
                    </button>
                    <input type="file" name="files[]" id="fileInptImg" ref="uploadTelegrama" @change="uploadDocumentoTelegrama" v-show="false" accept="application/pdf">
                  </div>

                  <titulo-secao>Atendimentos para este processo</titulo-secao>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered table-striped b-t b-light" style="border-top: 1px solid #eaeff0;">
                      <thead>
                      <tr>
                        <th>Data do Contato</th>
                        <th>Origem</th>
                        <th>Nome</th>
                        <th>Fila de Atendimento</th>
                        <th>Data/Hora Agendamento</th>
                        <th v-if="ACL.check('excluir_atendimento_grv', currentUser.id)">Excluir</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="atendimento in data.atendimentos">
                        <td scope="row" v-if="atendimento.dataNotificacao" @click="openCadastroAtendimento(atendimento.id)" role="button" tabindex="0">
                          {{formatarData(atendimento.dataNotificacao, 'DD/MM/YYYY')}}
                        </td>
                        <td v-else @click="openCadastroAtendimento(atendimento.id)" role="button" tabindex="0"><i>Não informado</i></td>
                        <td scope="row" @click="openCadastroAtendimento(atendimento.id)" role="button" tabindex="0">
                          {{origem(atendimento.origem)}}
                        </td>
                        <td scope="row" @click="openCadastroAtendimento(atendimento.id)" role="button" tabindex="0">
                          {{atendimento.nome}}
                        </td>
                        <td scope="row" @click="openCadastroAtendimento(atendimento.id)" role="button" tabindex="0">
                          {{filaAtendimento(atendimento.filaAtendimento)}}
                        </td>
                        <td scope="row" v-if="atendimento.dataAgendamento" @click="openCadastroAtendimento(atendimento.id)" role="button" tabindex="0">
                          {{formatarData(atendimento.dataAgendamento, 'DD/MM/YYYY HH:mm')}}
                        </td>
                        <td v-else @click="openCadastroAtendimento(atendimento.id)" role="button" tabindex="0"><i>Não informado</i></td>
                        <td scope="row" role="button" tabindex="0"  v-if="ACL.check('excluir_atendimento_grv', currentUser.id)">
                          <button type="button" class="btn btn-danger btn-md m-l-xs btn-colsultaGrv" @click="deleteAtendimento(atendimento.id)" :disabled="!isGrvRegistrada">
                            Excluir
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="wrapper-sm m-t-n m-b" v-if="ACL.check('restrito_visitante', currentUser.id)">
                    <button
                      @click.prevent="openCadastroAtendimento"
                      class="btn btn-info btn-md m-l-xs btn-colsultaGrv"
                      v-if="isGrvRegistrada && podeAdicionarAtendimento"
                    >
                      <i class="fa fa-plus"></i> Cadastrar atendimento
                    </button>
                  </div>

                  <titulo-secao>Arquivos para GRVs</titulo-secao>
                  <arquivos-grv
                    :arquivos="data.arquivos"
                    :tipos-arquivo="dataRequired.tipoArquivo"
                    :tipos-arquivo-ocultar="tiposArquivoOcultar"
                  ></arquivos-grv>

                  <div class="wrapper" v-if="!isGgv">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv"  v-if="ACL.check('restrito_visitante', currentUser.id)">Salvar</button>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper" v-else>
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-block btn-lg" v-if="ACL.check('restrito_visitante', currentUser.id)">Confirmar GGV</button>
                        <div class="text-center">
                          * a confirmação inclui imeditamente este bem no pátio e transmite as informações para o DETRO
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <popup-viewer :title="`${data.periciaRealizada ? 'Visualização' : 'Cadastro'} de perícia para a GRV ${data.numero}`" v-if="showFormPericia" @close="closeFormPericia">
        <pericia :grvId="data.id" :periciaId="data.pericia && data.pericia.id" @finishSubmit="closeFormPericia" />
      </popup-viewer>
      <popup-viewer title="Cadastro de Policial" v-if="showFormPolicial" @close="closeFormPolicial">
        <CadastroPolicial @finishSubmit="closeFormPolicial" viewer-mode/>
      </popup-viewer>
      <popup-viewer :title="`${atendimentoSelecionado ? 'Visualização' : 'Cadastro'} de atendimento para a GRV ${data.numero}`" v-if="showFormAtendimento" @close="closeFormAtendimento">
        <NovaCadastroNotificacaoAtendimento :grv="data" :atendimentoId="atendimentoSelecionado" @finishSubmit="closeFormAtendimento" />
      </popup-viewer>
      <popup-viewer :title="`${telegramaSelecionado ? 'Visualização' : 'Cadastro'} de telegrama para a GRV ${data.numero}`" v-if="showFormTelegrama" @close="closeFormTelegrama">
        <NovoCadastroNotificacaoTelegrama :grv="data" :telegramaId="telegramaSelecionado" @finishSubmit="closeFormTelegrama" />
      </popup-viewer>
    </div>
  </transition>
</template>

<style scoped>
.form-grv label {
  cursor: pointer;
}

.btn-colsultaGrv {
  padding-top: 7px;
  padding-bottom: 7px;
}

/* Raphael */
.autocomplete-input {
  position: relative;
}
.autocomplete-input input {
  width: 100%;
  height: 100%;
}
.autocomplete-input ul {
  position: absolute;
  border: #999 1px solid;
  list-style-type: none;
  width: 100%;
  max-height: 80px;
  overflow: auto;
  background-color: #fff;
  z-index: 99;
}
.autocomplete-input ul li {
  padding: 5px;
  cursor: pointer;
}
.autocomplete-input ul li:hover {
  background-color: #fff;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// Grv.vue?0a44c637